import React, { useEffect, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import performPopup from '../../images/perform-popup-promo.svg';
import performClosePopUp from '../../images/icon-close-popup.svg';
import '../../sass/components/_components.plannuhPopup.scss';
import imageInfo from '../../images/icon-info.svg';

const PlannuhPopup = ({ graphData }) => {

    const [plannuhpopupCheckLive, setPlannuhPopupCheckLive] = useState(true);
    const closePlannuPopup = (val) => {
        setPlannuhPopupCheckLive(val);
    }

    const [cookieTime, setCookieTime] = useState(true);

    useEffect(() => {

        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        if (document.cookie.includes('performupsell=true')) {
            setCookieTime(false);
            console.log('cookied');
        }
        else {
            console.log('not cookied');
            setTimeout(() => {
                setCookie('performupsell', true, 1);
                console.log('cookied now');
            }, 10000);
        }

    });

    const [toggle, setToggle] = useState(false);

    const toggleContent = (val) => {
        setToggle(val);
    }

    return (
        <>
            {plannuhpopupCheckLive &&
                <>
                    {graphData.plannuhPopup.plannuhPopupCheck === 'yes' &&
                        <>
                            {graphData.slug === 'home' || graphData.slug === 'new-homepage-2023' ?
                                <>
                                    {cookieTime &&
                                        <>
                                            <div className="cp-plannuhPopup l--perform" style={{ backgroundColor: "#fff" }}>
                                                <h3>Attend Perform23 Virtually for FREE</h3>
                                                <img src={performPopup} alt="Planful Perform 2023 in Chicago, IL" />
                                                <p>In-person tickets are selling out quickly. Join us virtually and <strong>get free CPE credits.</strong></p>
                                                <div className="cp-plannuhPopup__links l--flex">
                                                    <a className="l-button" href="https://hopin.com/events/perform-2023" target="_blank">Register Today</a>
                                                    <button onClick={() => closePlannuPopup(false)}>
                                                        <img src={performClosePopUp} alt="close popup" />
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </>
                                :
                                graphData.slug === 'jobs' || graphData.slug === 'careers-list' ?
                                    <div className={`cp-plannuhPopup l--jobs ${toggle ? "l-isActive" : ""}`} style={{ backgroundColor: "#E5DCFF" }}>
                                        <img src={imageInfo} alt="Info" />
                                        <p>The Planful team has been made aware of fraudulent job posts and phishing scams targeting job seekers applying for open roles at our company and posing as employees of the Planful recruiting team.</p>
                                        {toggle &&
                                            <>
                                                <div className="l--contentToggle">
                                                    <p>This is unfortunately also happening with a number of other software companies we are aware of. </p>
                                                    <p>All Planful recruitment-related communications will always come from a Planful employee with a Planful email address and never through a third-party individual, company, or website. </p>
                                                    <p>Planful’s recruitment process is a multi-step process that will always include multiple live calls via a Planful Zoom account, our internal video conferencing solution.</p>
                                                    <p>During the interview process, Planful will never ask for:</p>
                                                    <ul>
                                                        <li>Your banking details</li>
                                                        <li>Money</li>
                                                        <li>Confidential information outside of what is listed on your resume</li>
                                                        <li>Ask you to download tools to facilitate the interview</li>
                                                        <li>Facilitate our interview process via text only</li>
                                                        <li>Extend offers without going through our multi-step process</li>
                                                    </ul>
                                                    <p>If you believe you have been the victim of a crime related to one of these scams, please report the instance to your local government entity, such as local law enforcement, the FBI’s <a href="https://www.ic3.gov/Home/ComplaintChoice" target="_blank">Internet Crime Complaint Center</a>, or the <a href="https://reportfraud.ftc.gov/#/" target="_blank">Federal Trade Commission (FTC).</a></p>
                                                    <p>If you are unsure about the legitimacy of a Planful application conversation, please reach out to <a href="mailto:people@planful.com">people@planful.com</a> or <a href="mailto:recruiting@planful.com">recruiting@planful.com</a> and our team will respond as quickly as possible.</p>
                                                </div>
                                                <button className="l-textlink" onClick={() => toggleContent(false)}>Read less</button>
                                            </>
                                        }
                                        <div className="cp-plannuhPopup__links l--flex">
                                            {!toggle &&
                                                <button className="l-textlink" onClick={() => toggleContent(true)}>Read more</button>
                                            }
                                            <button className="l-button" onClick={() => closePlannuPopup(false)}>
                                                <span>Dismiss</span>
                                                <StaticImage onClick={() => closePlannuPopup(false)} src="../../images/icon-cross-popup-jobs.svg" alt="Info" />
                                            </button>
                                        </div>
                                    </div>
                                    :
                                    ""
                            }
                        </>
                    }
                </>
            }
        </>
    );
}

export default PlannuhPopup;